import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import {
  SelectField,
  TextInputField,
} from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useCreateRack from '../../../hooks/racks/useCreateRack';
import {
  CreateRackDataType,
  createRackInitialValues,
  CreateRackSchema,
} from '../../../models/createRack/createRack.model';
import { useAppSelector } from '../../../redux/store';

const CreateRackModal = () => {
  const authAction = useAppSelector((state) => state.auth);
  const { createRack, loading } = useCreateRack();

  const onSubmit = (values: CreateRackDataType, actions: any) => {
    const data = {
      ...values,
      rackStatus: values.rackStatus === 'Available' ? true : false,
      warehouseId: authAction!.authData!.user.warehouseId,
    };
    createRack(data);

    // if (resetInputFields) {
    actions.resetForm(createRackInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Create Rack'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={createRackInitialValues}
          schema={CreateRackSchema}
          onSubmit={onSubmit}
        >
          <TextInputField
            label="Bin Number"
            name="binCount"
            type="number"
            // type="text"
            placeholder="Enter Bin Number"
            className="full"
          />
          <TextInputField
            label="Rack Name"
            name="rackName"
            type="text"
            placeholder="Enter Rack Name"
            className="full"
          />
          <TextInputField
            label="Rack Type"
            name="rackType"
            type="text"
            placeholder="Enter Rack Type"
            className="full"
          />
          <SelectField label="Rack Status" name="rackStatus">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Rack Status'}
            </option>
            <option>Available</option>
            <option>Not Available</option>
          </SelectField>

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Create Rack
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default CreateRackModal;

const Container = styled.div`
  display: flex;
  /* border: 2px solid red; */
  justify-content: space-between;
  align-items: center;
`;
